/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import { object, func } from 'prop-types';
import { TextField, InputAdornment } from '@material-ui/core';
import SortIcon from '@material-ui/icons/Sort';
import useDebounce from '../../../../../../../helpers/hooks/useDebounce';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    // reset border color of textbox on focus
    root: {
        "& .mbp-account-MuiOutlinedInput-root.Mui-focused .mbp-account-MuiOutlinedInput-notchedOutline": {
            borderColor: "black",
        },
    },
});
const SearchFilter = ({ recipients, setRecipients, recipientData }) => {
    const [searchValue, setSearchValue] = useState('');
    const [isAscending, setIsAscending] = useState(true);
    const debouncedSearchValue = useDebounce(searchValue, 500);
    const classes = useStyles();
    const filterRecipientData = (recipients) => {
        const { addressBookResponse } = recipients;
        let filteredRecipientsByName = addressBookResponse?.addressList?.filter((recipient) => {
            if ((recipient?.rcpFirstName && recipient?.rcpLastName) || recipient?.rcpEmployerName) {
                const { rcpFirstName, rcpLastName, rcpEmployerName } = recipient;
                return (
                    rcpFirstName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    rcpLastName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    `${rcpFirstName} ${rcpLastName}`.toLowerCase().includes(searchValue.toLowerCase()) ||
                    rcpEmployerName?.toLowerCase().includes(searchValue.toLowerCase())
                );
            }
            return false;
        });

        if (filteredRecipientsByName?.length > 0) {
            filteredRecipientsByName = filteredRecipientsByName.sort((a, b) => {
                const nameA = (a.rcpFirstName || "").toLowerCase();
                const nameB = (b.rcpFirstName || "").toLowerCase();
                return isAscending ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
            });
            setRecipients({
                addressBookResponse: {
                    ...addressBookResponse,
                    addressList: filteredRecipientsByName,
                    totalEntries: filteredRecipientsByName.length,
                },
            });
        }
    };

    useEffect(() => {
        if (debouncedSearchValue) {
            filterRecipientData(recipients);
        } else {
            filterRecipientData(recipientData);
        }
    }, [debouncedSearchValue, isAscending])

    const toggleSortDirection = () => setIsAscending(!isAscending);

    return (
        <TextField
            placeholder="Search Name"
            fullWidth
            variant="outlined"
            onChange={(e) => setSearchValue(e.target.value)}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                            <SortIcon onClick={toggleSortDirection} style={{cursor: 'pointer'}}/>
                    </InputAdornment>
                ),
            }}
            classes={{ root: classes.root }}
        />
    );
};

SearchFilter.propTypes = {
    recipients: object.isRequired,
    setRecipients: func.isRequired,
    recipientData: object.isRequired,
};

export default SearchFilter;
